async function getData() {
  const arrayData = []
  const productIds = []
  const bestSell = window.location.href.includes(".pt/es") ? 
    "Los más vendidos en " : 
    "Os mais vendidos em "

  await fetch(`${ENDPOINT}?action=product_rankings&store=${STORE}`)
    .then((res) => {
      if (!res.ok) {
        throw new Error(`${res.status} ${res.statusText}`)  
      }
      
      return res.json()
    })
    .then(({ data }) => {
      arrayData.push(data)
      localStorage.setItem("product_rankings", JSON.stringify(arrayData))
    })
    .catch(console.error)
  
  Object.entries(arrayData[0]).forEach(([category, products]) => {
    const categoryTranslations = {
      "Alimentação": "Alimentación",
      "Charcutaria": "Charcutería",
      "Garrafeira": "Bodega",
      "Produtos Congelados": "Productos Congelados",
      "Produtos Refrigerados": "Productos Refrigerados",
      "Dph": "Dph"
    }

    const categoryClear = category
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(" ", "")
    const categoryTranslated = window.location.href.includes(".pt/es") ? 
      categoryTranslations[category] : 
      category

    const collectionProductWrapper = document.createElement("div")
    collectionProductWrapper.classList.add("collection-product")
    collectionProductWrapper.setAttribute("id", `category-${category}`)

    const pageWidth = document.createElement("div")
    pageWidth.classList.add("page-width")
    pageWidth.classList.add("slider-newproduct-wrap")

    const container = document.createElement("div")
    container.classList.add("container")
    container.style.position = "relative"

    const header = document.createElement("div")
    header.classList.add("section-header")

    const h2 = document.createElement("h2")
    h2.classList.add("tt-title")
    h2.innerText = bestSell + categoryTranslated

    const customNavigation = document.createElement("div")
    customNavigation.classList.add("customNavigation")
    customNavigation.classList.add("bestsellers")
    customNavigation.classList.add("hideme")

    const navigationWrap = document.createElement("div")
    navigationWrap.classList.add("navigation_wrap")

    const chevronLeft = document.createElement("a")
    chevronLeft.classList.add("prev")
    chevronLeft.classList.add("mdi-chevron-left")
    chevronLeft.setAttribute("onclick", "prevProd($(this))")
    chevronLeft.innerText = "Anterior"

    const chevronRight = document.createElement("a")
    chevronRight.classList.add("next")
    chevronRight.classList.add("mdi-chevron-right")
    chevronRight.setAttribute("onclick", "nextProd($(this))")
    chevronRight.innerText = "Próximo"

    const row = document.createElement("div")
    row.classList.add("row")

    const newProduct = document.createElement("div")
    newProduct.classList.add("new-product-div")
    newProduct.classList.add("container")
    newProduct.setAttribute("id", categoryClear.toUpperCase())
    
    const bestsellerProducts = document.createElement("div")
    bestsellerProducts.setAttribute("id", "bestseller-products")
    bestsellerProducts.classList.add("grid")
    bestsellerProducts.classList.add("grid--view-items")

    Object.values(products).forEach((value) => {
      productIds.push("gid://shopify/Product/" + value)
    })

    collectionProductWrapper.append(pageWidth)
    pageWidth.append(container)
    container.append(header, customNavigation, row)
    row.append(newProduct)
    newProduct.append(bestsellerProducts)
    customNavigation.append(navigationWrap)
    navigationWrap.append(chevronLeft, chevronRight)
    header.append(h2)

    const bestsellersContainer = document.querySelector("#bestsellers")?.append(collectionProductWrapper)
  })

  fetchData(productIds)
}

function fetchData(data) {
  const query = `
    {
      nodes(ids: ${JSON.stringify(data)}) {
        ... on Product {
          id
          title
          handle
          availableForSale
          tags
          productType
          featuredImage{
            url
            altText
          }
          variants(first: 1) {
            edges {
              node {
                id
                sku
                priceV2 {
                  amount
                }
                compareAtPriceV2 {
                  amount
                }
              }
            }
          }
        }
      }
    }
  `

  fetch(SHOPIFY_STORE_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Shopify-Storefront-Access-Token": ACCESS_TOKEN
    },
    body: JSON.stringify({ query })
  })
    .then((res) => {
      if (!res.ok) {
        throw new Error(`${res.status} ${res.statusText}`)
      }

      return res.json()
    })
    .then(async ({ data }) => {
      if (data.nodes) {
        await generaterowItems(data.nodes)
      }
    })
    .catch(console.error)
}

async function generaterowItems(nodes) {
  const __OBJ = {
    "alimentacao": {
      "tag": "Alimentação",
      "products": []
    },
    "charcutaria": {
      "tag": "Charcutaria",
      "products": []
    },
    "produtosCongelados": {
      "tag": "Produtos Congelados",
      "products": []
    },
    "garrafeira": {
      "tag": "Garrafeira",
      "products": []
    },
    "dph": {
      "tag": "Dph",
      "products": []
    },
    "produtosRefrigerados": {
      "tag": "Produtos Refrigerados",
      "products": []
    }
  }

  for (const node of nodes) {
    node?.tags.forEach((tag) => {
      const foundKey = Object.entries(__OBJ).find(([_, value]) => value.tag === tag)

      if (foundKey) {
        __OBJ[foundKey[0]].products.push(node)
      }
    })
  }

  Object.entries(__OBJ).forEach(async ([key, value]) => {
    generateCategoryHTML(value.products, key.toUpperCase())
  })
}

function generateCategoryHTML(products, categoryId) {
  const row = document.createElement("div")
  row.classList.add("row")

  const productGrid = document.createElement("div")
  productGrid.classList.add("product-grid")
  productGrid.classList.add("carousel_bestsellers")
  productGrid.setAttribute("id", `carousel_products_${categoryId}`)
  productGrid.setAttribute("data-flickity", JSON.stringify({ "groupCells": true }))

  const iecas = loadFromMemory("iecas") ?? {}
  const prices = loadFromMemory("prices") ?? {}

  row.append(productGrid)

  products?.forEach((item) => {
    const {
      variants = [],
      availableForSale = false,
      tags = [],
      id = null,
      featuredImage = null,
      handle = "",
      title = ""
    } = item ?? {};

    const edges = variants?.edges
    const edgesIsArray = Array.isArray(edges)
    const compareAtPrice = edgesIsArray ? 
      edges[0].node?.compareAtPriceV2 : 
      0
    const amount = edgesIsArray ? 
      edges[0].node?.priceV2?.amount : 
      0
    const sku = edgesIsArray ? 
      edges[0].node?.sku : 
      ""
    const soldOut = availableForSale ?? "sold-out"
    const onSale = parseFloat(compareAtPrice) > parseFloat(amount) ? "on-sale" : ""
    const unityMeasure = tags.find((tag) => tag.includes("unity_measure_")).replace("unity_measure_", "") ?? ""
    const prodId = id.replace("gid://shopify/Product/", "")
    const featuredImageURL = featuredImage?.url ?? "https://portal.marvanejo.pt/cdn/shop/files/logo_marvanejo-_1_5_96445930-c4db-4c87-bbef-117a909b53a7_220x.jpg?v=1643391456"

    const gridItem = document.createElement("div")
    gridItem.classList.add("grid-item")
    gridItem.classList.add("p-0")

    const dataId = document.createElement("div")
    dataId.setAttribute("id", `product-${prodId}`)
    dataId.classList.add("grid-view-item")
    dataId.classList.add("product-layouts")
    dataId.classList.add("item-row")

    if (soldOut) dataId.classList.add(soldOut)
    if (onSale) dataId.classList.add(onSale)

    const productWrapper = document.createElement("div")
    productWrapper.classList.add("product-wrapper")

    const productThumb = document.createElement("div")
    productThumb.classList.add("product-thumb")

    const productImage = document.createElement("div")
    productImage.classList.add("product-image")
    productImage.classList.add("col-xs-12")
    productImage.classList.add("padding_0")

    const anchorProductTag = document.createElement("a")
    anchorProductTag.classList.add("product-t")
    anchorProductTag.href = `/products/${handle}`

    const imgProductTag = document.createElement("img")
    imgProductTag.classList.add("featured-image")
    imgProductTag.classList.add("image_thumb")
    imgProductTag.src = featuredImageURL
    imgProductTag.alt = title

    anchorProductTag.append(imgProductTag)
    productImage.append(anchorProductTag)
    productThumb.append(productImage)
    productWrapper.append(productThumb)

    const productDescription = document.createElement("div")
    productDescription.classList.add("product-description")

    const productDescriptionWrap = document.createElement("div")
    productDescriptionWrap.classList.add("product-description-wrap")

    const priceBtn = document.createElement("div")
    priceBtn.classList.add("price-btn")

    const gridViewItem = document.createElement("div")
    gridViewItem.classList.add("grid-view-item__vendor")
    gridViewItem.classList.add("grid-item-meta")
    gridViewItem.classList.add("prod_item_title")
    gridViewItem.style.textAlign = "left"

    const anchorGridViewItemTag = document.createElement("div")
    gridViewItem.classList.add("grid-view-item__link")
    gridViewItem.classList.add("grid-link__title")
    gridViewItem.href = `/products/${handle}`
    gridViewItem.innerText = title

    gridViewItem.append(anchorGridViewItemTag)

    const gridViewItemMeta = document.createElement("div")
    gridViewItemMeta.classList.add("grid-view-item__meta")

    const gridLinkPrice = document.createElement("div")
    gridLinkPrice.classList.add("grid-link__org_price")
    gridLinkPrice.style.float = "left"

    const productPrice = iecas[sku] ?? prices[sku]
    const finalPrice = isNaN(parseFloat(productPrice)) ? amount : productPrice

    const customPriceSpan = document.createElement("span")
    customPriceSpan.classList.add("custom-price")
    customPriceSpan.classList.add("product-price__price")
    customPriceSpan.setAttribute("data-price", finalPrice)
    customPriceSpan.setAttribute("data-sku", sku)
    customPriceSpan.textContent = new Intl.NumberFormat("pt-PT", {
      style: "currency",
      currency: "EUR"
    }).format(finalPrice)

    gridLinkPrice.append(customPriceSpan)

    const addToCartBtn = document.createElement("div")
    addToCartBtn.classList.add("pro_btn")
    addToCartBtn.classList.add("add_tocart")
    addToCartBtn.style.display = "flex"
    addToCartBtn.style.alignItems = "center"
    addToCartBtn.style.justifyContent = "flex-end"

    const quantityGrid = document.createElement("div")
    quantityGrid.classList.add("qnty_grid")
    quantityGrid.style.position = "relative"
    quantityGrid.style.width = "100px"

    const inputQnty = document.createElement("input")
    inputQnty.classList.add("form-control")
    inputQnty.type = "number"
    inputQnty.step = 1
    inputQnty.min = 1
    inputQnty.setAttribute("sku-value", sku)
    inputQnty.value = 1
    inputQnty.style.marginBottom = "0"
    inputQnty.style.width = "100%"
    inputQnty.style.height = "40px"
    inputQnty.style.padding = "0"
    inputQnty.style.fontSize = "18px"
    inputQnty.style.textAlign = "center"

    const quantityNav = document.createElement("div")
    quantityNav.classList.add("quantity-nav")
    quantityNav.type = "number"
    quantityNav.step = 1
    quantityNav.min = 1
    quantityNav.setAttribute("sku-value", sku)
    quantityNav.value = 1
    quantityNav.style.position = "absolute"
    quantityNav.style.right = "-25%"
    quantityNav.style.height = "100%"
    quantityNav.style.top = "0"
    quantityNav.style.width = "100%"
    quantityNav.style.pointerEvents = "none"

    const quantitySpanBtnDown = document.createElement("span")
    quantitySpanBtnDown.classList.add("quantity-button")
    quantitySpanBtnDown.classList.add("quantity-down")
    quantitySpanBtnDown.type = "number"
    quantitySpanBtnDown.step = 1
    quantitySpanBtnDown.min = 1
    quantitySpanBtnDown.setAttribute("sku-value", sku)
    quantitySpanBtnDown.value = 1
    quantitySpanBtnDown.style.position = "absolute"
    quantitySpanBtnDown.style.left = 0
    quantitySpanBtnDown.style.height = "100%"
    quantitySpanBtnDown.style.display = "flex"
    quantitySpanBtnDown.style.width = "30px"
    quantitySpanBtnDown.style.pointerEvents = "all"
    quantitySpanBtnDown.style.alignItems = "center"
    quantitySpanBtnDown.style.justifyContent = "center"
    quantitySpanBtnDown.style.border = "none"
    quantitySpanBtnDown.style.fontSize = "20px"
    quantitySpanBtnDown.setAttribute("onclick", "changeQntyGrid($(this))")
    quantitySpanBtnDown.innerText = "-"

    const quantitySpanBtnUp = document.createElement("span")
    quantitySpanBtnUp.classList.add("quantity-button")
    quantitySpanBtnUp.classList.add("quantity-up")
    quantitySpanBtnUp.type = "number"
    quantitySpanBtnUp.step = 1
    quantitySpanBtnUp.min = 1
    quantitySpanBtnUp.setAttribute("sku-value", sku)
    quantitySpanBtnUp.value = 1
    quantitySpanBtnUp.style.position = "absolute"
    quantitySpanBtnUp.style.right = 0
    quantitySpanBtnUp.style.height = "100%"
    quantitySpanBtnUp.style.display = "flex"
    quantitySpanBtnUp.style.width = "30px"
    quantitySpanBtnUp.style.pointerEvents = "all"
    quantitySpanBtnUp.style.alignItems = "center"
    quantitySpanBtnUp.style.justifyContent = "center"
    quantitySpanBtnUp.style.border = "none"
    quantitySpanBtnUp.style.fontSize = "20px"
    quantitySpanBtnUp.setAttribute("onclick", "changeQntyGrid($(this))")
    quantitySpanBtnUp.innerText = "+"

    quantityNav.append(quantitySpanBtnDown, quantitySpanBtnUp)
    quantityGrid.append(inputQnty, quantityNav)

    const formAdd = document.createElement("form")
    formAdd.classList.add("variants")
    formAdd.classList.add("clearfix")
    formAdd.classList.add(`cart-form-${prodId}`)
    formAdd.action = "/cart/add"
    formAdd.method = "post"

    addToCartBtn.append(quantityGrid)
    addToCartBtn.append(document.createTextNode(`/${unityMeasure}`))
    addToCartBtn.append(formAdd)

    if (unityMeasure) {
      const inputUnityMeasure = document.createElement("input")
      inputUnityMeasure.type = "hidden"
      inputUnityMeasure.name = "properties[Unity of Measure]"
      inputUnityMeasure.value = unityMeasure

      formAdd.append(inputUnityMeasure)
    }

    const inputId = document.createElement("input")
    inputId.type = "hidden"
    inputId.name = "id"
    inputId.value = prodId

    const addToBasketEl = document.createElement("a")
    addToBasketEl.setAttribute("onclick", "addToBasketRanking($(this))")
    addToBasketEl.href = "#"
    addToBasketEl.setAttribute("data-add", sku)
    addToBasketEl.setAttribute("data-image", featuredImage)

    const imgLogo = document.createElement("img")
    imgLogo.src = "https://cdn.shopify.com/s/files/1/0288/6559/3432/files/icon.png?v=1718362406"
    imgLogo.style.width = "50px"

    addToBasketEl.append(imgLogo)
    formAdd.append(inputId, addToBasketEl)
    gridViewItemMeta.append(gridLinkPrice, addToCartBtn)
    productDescriptionWrap.append(priceBtn)
    priceBtn.append(gridViewItem, gridViewItemMeta)
    productDescription.append(productDescriptionWrap)
    productWrapper.append(productDescription)
    dataId.append(productWrapper)
    gridItem.append(dataId)
    productGrid.append(gridItem)
  })

  $(`#${categoryId} #bestseller-products`)[0]?.append(row)

  $(`#carousel_products_${categoryId}`).flickity({
    cellAlign: "left",
    contain: true,
    pageDots: false
  })
}

function prevProd(data) {
  const categoryProd = $(data)
    .parent()
    .parent()
    .parent()
    .find(".new-product-div")
    .attr("id")

  $(`#${categoryProd} .flickity-prev-next-button.previous`).click()
}

function nextProd(data) {
  const categoryProd = $(data)
    .parent()
    .parent()
    .parent()
    .find(".new-product-div")
    .attr("id")

  $(`#${categoryProd} .flickity-prev-next-button.next`).click()
}
